import VCard from '../CardSlider/VCard';
import { formatImageUrlByDevice, formatUrl } from '../../helpers/Helper';

const RenderSearchPost = (props) => {
  let propsData = props.props;
  let { deviceType } = props.props;
  let posts = [],
      searchPost = propsData && (propsData.posts || propsData.postSuggestions);
  if (searchPost) {
    let results = searchPost;
    results.map((prop, idx) => {
      let eachPost = prop,
          link = formatUrl(eachPost.slug,eachPost.redirect);
      posts.push(
        <VCard
          key={'card-' + idx}
          slug={"/" + link}
          title={eachPost.title}
          image={eachPost.featured_media && formatImageUrlByDevice(eachPost.featured_media.name, deviceType)}
          subTitle={eachPost.sub_title}
          byline={eachPost.byline}
          categories={eachPost.categories ? eachPost.categories : null}
          tags={eachPost.tags && eachPost.tags.length > 0 ? eachPost.tags : null}
          noAuthor={eachPost.byline && eachPost.byline.length > 0 && eachPost.byline[0] !== null ? false : true}
          isCategoryPage={propsData.isCategoryPage}
          siteId={props.siteId}
          checked={false}
          className="contentCard"
          isLazyLoadImage = {propsData.isCategoryPage ? true : false}
        />
      )
    });
  }

  return posts
};

export default RenderSearchPost;
